var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('PaginatedAutocomplete',{attrs:{"filter-dropdown":new _vm.DropdownFilter({
      itemsModuleName: 'colorsModule',
      initialValue: _vm.initialValue ? _vm.initialValue.map(function (val) { return val.id; }) : [],
    }),"filter":_vm.filter,"data-test":"colorGroup-colors","on-change":_vm.onChange,"clearable":"","multiple":"","deletable-chips":"","placeholder":"Assign Colors for the Color Group"},scopedSlots:_vm._u([{key:"before-selection-name",fn:function(ref){
    var item = ref.item;
return [_c('span',{staticClass:"color-preview",style:({ background: item.value })})]}},{key:"before-item-name",fn:function(ref){
    var item = ref.item;
return [_c('span',{staticClass:"color-preview",style:({ background: item.value })})]}},{key:"after-item-name",fn:function(ref){
    var item = ref.item;
return [_c('span',{staticClass:"hex"},[_vm._v("("+_vm._s(item.value)+")")])]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }